import { Link } from "react-router-dom"
import MarafyeLogo from "../Brand/MarafyeLogo"

const NavLeft = () => {
  return (
    <Link className="navbar-brand py-2" to="/" aria-label="Marafye home">
      <MarafyeLogo size={44} variant="onDark" />
    </Link>
  )
}

export default NavLeft
